<app-button
    class="top-button"
    [buttonType]="(buttonType$ | async) ?? 'basic-primary'"
    (buttonClick)="handleClick()"
    icon="arrow-up"
    iconPosition="right"
>
    <translate>Back to top</translate>
</app-button>
